import { render, staticRenderFns } from "./CreateAccountPage.vue?vue&type=template&id=6041578c&"
import script from "./CreateAccountPage.vue?vue&type=script&lang=js&"
export * from "./CreateAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports